import Link from 'next/link';
import { Container, SectionRule } from '../ReferenceChrome';

const LINKS = {
  Product: [
    { label: 'Features', href: '/#features' },
    { label: 'How it Works', href: '/how-it-works' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Why RankGrip', href: '/why-rankgrip' },
  ],
  Company: [
    { label: 'About', href: '/why-rankgrip' },
    { label: 'Blog', href: '/blog' },
    { label: 'Industry Solutions', href: '/industry-solutions' },
    { label: 'Contact', href: 'mailto:teamrankgrip@gmail.com' },
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/legal/privacy-policy' },
    { label: 'Terms of Service', href: '/legal/terms-of-service' },
    { label: 'Data Processing Agreement', href: '/legal/dpa' },
  ],
};

export function FooterRef() {
  return (
    <footer className="relative bg-white pb-12 sm:pb-16 overflow-hidden">
      
      <div className="relative z-10">
        <SectionRule />
        <Container className="pt-12 sm:pt-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-4">
          {/* Brand column */}
          <div className="sm:col-span-1 flex flex-col items-center sm:items-start text-center sm:text-left">
            <Link href="/" className="inline-flex items-center">
              <img src="/logo-name.svg" alt="RankGrip" className="h-12 w-auto" />
            </Link>
            <p className="mt-4 max-w-xs text-sm font-light leading-relaxed text-gray-500">
              The intuitive SEO platform that turns keyword gaps into high-ranking content
              through automation and rank tracking.
            </p>
          </div>

          {/* Link columns */}
          {Object.entries(LINKS).map(([group, links]) => (
            <div key={group} className="text-center sm:text-left">
              <h4 className="text-sm font-semibold text-gray-800">{group}</h4>
              <ul className="mt-4 space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      href={link.href}
                      className="text-sm font-light text-gray-500 transition-colors hover:text-gray-900"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="mt-12 flex items-center justify-center border-t border-gray-100 pt-8">
          <p className="text-sm font-light text-center text-gray-400">
            © {new Date().getFullYear()} RankGrip. All rights reserved.
          </p>
          </div>
        </Container>
      </div>
    </footer>
  );
}
